module.exports = __webpack_public_path__ + "static/media/selected_port_marker.09858ad2.svg";